<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import axios from "@/axios";
import ExportButton from "@/components/export-button";
// import moment from "moment";
import { getDateWithFormat, formatCurrency, thousandSeparator, b64toBlob } from "@/utils";
import DPConfig from "../../../components/dataPickerConf";
import Filter from "@/components/filters/Filter";
import Headers from "./table_headers";

export default {
  page: {
      title: "Convenios",
      meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
      Layout,
      filters: Filter,
      "export-button": ExportButton,
  },
  data(){
    return{
      lang: {
          formatLocale: DPConfig.formatLocale
      },
      tableData: [],
      currentPage: 1,
      perPage: 10,
      totRegistros: 1,
      daterange: [new Date("2000-01-01"), new Date()],
      isBusy: false,
      buttonClicked: undefined,
      filtersValue: {
          rutEmpresa: 0,
          period: [new Date("2000-01-01"), new Date()],
      },
      fields: Headers.convenio,
      dataExport: []
    }
  },
  methods:{
    getDate(date) {
      return getDateWithFormat(date);
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    getNumberWithSeparators(number) {
      return thousandSeparator(number);
    },
    toBlob(b64Data, contentType = ""){
      return b64toBlob(b64Data, contentType)
    },
    getConvenios() {
      if(this.filtersValue.rutEmpresa) {
        this.isBusy = true;
        axios.get(`/GetConvenios?` +
            `RutEmpresa=${this.filtersValue.rutEmpresa}&` +
            `Pagina=${this.currentPage}&` +
            `Registros=${this.perPage}`
          )
        // axios.get(`/GetConvenios?` +
        //     `RutEmpresa=${this.filtersValue.rutEmpresa}&` +
        //     `Pagina=${this.currentPage}&` +
        //     `Registros=${this.perPage}&` +
        //     `fechaDesde=${this.filtersValue.period[0] ? moment(this.filtersValue.period[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD')}&` +
        //     `fechaHasta=${this.filtersValue.period[1] ? moment(this.filtersValue.period[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD')}
        //   `)
            .then((convenios) => {
              this.tableData = convenios.data;
              this.totRegistros = convenios.data.length;
              this.isBusy = false;
              this.getToExport()
            })
            .catch((error) => {
              if (error.response) {
                this.$bvToast.toast(
                    this.$t("lease.request.error.message").toString(),
                    {
                      title: this.$t("lease.request.error.nonFound").toString(),
                      variant: "danger",
                      solid: true,
                    }
                );
              }
              this.isBusy = false;
            });
          }
        },
    getToExport(){
      if(this.filtersValue.rutEmpresa){
        axios.get(`/GetConvenios?` +
            `RutEmpresa=${this.filtersValue.rutEmpresa}&` +
            `Pagina=1&` +
            `Registros=${this.totRegistros}`)
        // axios.get(`/GetConvenios?` +
        //     `RutEmpresa=${this.filtersValue.rutEmpresa}&` +
        //     `Pagina=1&` +
        //     `Registros=${this.totRegistros}&` +
        //     `fechaDesde=${this.filtersValue.period[0] ? moment(this.filtersValue.period[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD')}&` +
        //     `fechaHasta=${this.filtersValue.period[1] ? moment(this.filtersValue.period[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD')}
        //           `)
            .then((convenios) => {
              let conveniosData = convenios.data
              for(const convenio of conveniosData) {
                convenio.deudaFacturada = convenio.deuda
                delete convenio.deuda
                delete convenio.numeroContrato
              }
              this.dataExport = conveniosData;
            })
      }
    },
    navigateToDetail(row) {
      this.$store.dispatch("hideValue/updateId", row.value);
      this.$store.dispatch("hideValue/updateFilter", this.filtersValue);
      this.$router.push({ name: "detalleContrato" });
    },
      downloadConvenio(row) {
          this.buttonClicked = row.item.idConvenio;
          if (row.item.documentos.length === 1) {
            axios
                .get(`/GetDocument/${row.item.documentos[0].documentoid}`)
                .then((documento) => {
                if(documento.data){
                    const blob = this.toBlob(documento.data.data, "application/pdf");
                    let fileURL = window.URL.createObjectURL(blob);
                    let fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", `convenio_${row.item.idConvenio}.pdf`);
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    this.buttonClicked = undefined;
                }else{
                    alert("No es posible descargar el convenio");
                    this.buttonClicked = undefined;
                }
                })
                .catch(() => {
                this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
                    title: this.$t("lease.pdf.error.download").toString(),
                    variant: "danger",
                    solid: true,
                });
                this.buttonClicked = undefined;
                })
            }
            // TODO: Agregar la opcion de descarga si son mas de un documento. Los ejemplos de prueba solo contienen un documento.
          },
      },
}
</script>

<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <b-row align-h="between" align-v="center" class="title">
                            <h4 class="card-tittle custom-title">CONVENIOS</h4>
                            <export-button :data="dataExport" fileName="CONVENIOS_" />
                        </b-row>
                        <filters v-show="false" v-model="filtersValue" @change="getConvenios" />
                        
                        <!-- Inicio Tabla -->
                        <div class="table-responsive mb-0">
                        <b-table
                            :items="tableData"
                            :fields="fields"
                            responsive="sm"                
                            :current-page="currentPage"                
                            :busy="isBusy"
                            show-empty
                        >
                            <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                            <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            </template>
                            <!-- Fin Spinner en estado "ocupado" de la tabla -->

                            <template>
                              <h5 style="text-align: center">
                                {{ $t("request.table.empty") }} 
                              </h5>
                            </template>
                            <template #cell(descargar)="row">
                              <div class="text-center" :id="`download-div-${row.item}`">
                                <b-button variant="danger" @click="downloadConvenio(row)" :disabled="!row.item.documentos">
                                  <i v-if="buttonClicked !== row.item.idConvenio"
                                  class="bx bx-download font-size-16 align-middle" />
                                  <b-spinner v-else small class="align-middle"></b-spinner>
                                </b-button>
                              </div>
                              <b-tooltip :target="`download-div-${row.item}`" triggers="hover" placement="rigth" v-if="!row.item.documentos">
                                No existen documentos disponibles
                              </b-tooltip>
                            </template>
                            <template #cell(garantia)="row">
                                {{ row.value === "S/G" ? 'No' : 'Si'}}
                            </template>
                            <template #cell(saldo)="row">
                                {{ "$" + getCurrency(row.value) }}
                            </template>
                            <template #cell(lineaCredito)="row">
                                {{ "$" + getCurrency(row.value) }}
                            </template>
                            <template #cell(numeroContrato)="row">
                                {{ row.value }}
                            </template>
                        </b-table>
                        </div>
                        <!-- Fin Tabla -->
                        <!-- Inicio Paginación -->
                        <div class="col">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination
                                class="portal"
                                v-model="currentPage"
                                :per-page="perPage"
                                :total-rows="totRegistros">
                            </b-pagination>
                            </ul>
                        </div>
                        </div>
                        <!-- Fin Paginación -->
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.custom-title{
    margin:0 !important;
    font-weight: bold;
}
.title{
    padding: 15px;
}
</style>
